import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "generateButton",
    "viewButton",
    "downloadButton"
  ];

  async showQuickLook(event) {
    event.preventDefault();

    const pupilToken = this.data.get("pupilToken");
    const docType = this.data.get("docType");
    const csrfToken = document.querySelector('meta[name="csrf-token"]').content;

    const response = await fetch(`/schools/pupils/${pupilToken}/documents/${docType}/quick-look`, {
      method: "GET",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        "X-CSRF-Token": csrfToken,
        "Accept": "text/vnd.turbo-stream.html"
      }
    });

    if (response.ok) {
      const quickViewElement = document.querySelector("#driving-school-document-quick-look");
      quickViewElement.dataset.pupilToken = pupilToken;
      quickViewElement.dataset.docType = docType;
      quickViewElement.classList.remove("u-hidden");

      const responseBody = await response.text();
      const parser = new DOMParser();
      const xmlDoc = parser.parseFromString(responseBody, "text/html");
      const template = xmlDoc.querySelector("template");

      if (template && quickViewElement) {
        quickViewElement.innerHTML = "";
        quickViewElement.appendChild(template.content.cloneNode(true));
      }
    }
  }

  closeQuickLook(event) {
    event.preventDefault();

    const quickViewElement = document.querySelector("#driving-school-document-quick-look");
    quickViewElement.classList.add("u-hidden");
  }

  disableGenerateButton(event) {
    const el = event.currentTarget;
    el.textContent = "Generating...";
    el.style.pointerEvents = "none";
    el.classList.add("Button--disabled");

    if (this.hasViewButtonTarget) {
      const view = this.viewButtonTarget;
      view.classList.add("Button--disabled");
      view.style.pointerEvents = "none";
      view.setAttribute("tabindex", "-1");
      view.setAttribute("aria-disabled", "true");
    }

    if (this.hasDownloadButtonTarget) {
      this.disableDownloadControl(this.downloadButtonTarget);
    }
  }

  disableDownloadControl(el) {
    if (el.tagName === "FORM") {
      el.style.pointerEvents = "none";
      const submit = el.querySelector(
        'button[type="submit"], input[type="submit"]'
      );
      if (submit) {
        submit.disabled = true;
        submit.classList.add("Button--disabled");
      }
    } else {
      el.disabled = true;
      el.classList.add("Button--disabled");
    }
  }

  toggleCheckboxSection(event) {
    const sectionId = event.currentTarget.dataset.sectionId;
    const section = document.getElementById(sectionId);
    if (!section) return;

    section.hidden = !event.currentTarget.checked;
  }

  toggleRadioSections(event) {
    const showSectionId = event.currentTarget.dataset.showSectionId;
    const hideSectionIds = (event.currentTarget.dataset.hideSectionIds || "")
      .split(",")
      .map((id) => id.trim())
      .filter(Boolean);

    if (showSectionId) {
      const showSection = document.getElementById(showSectionId);
      if (showSection) {
        showSection.hidden = false;
      }
    }

    hideSectionIds.forEach((sectionId) => {
      const section = document.getElementById(sectionId);
      if (section) {
        section.hidden = true;
      }
    });
  }

  generateDocument() {
    if (this.hasGenerateButtonTarget) {
      this.generateButtonTarget.disabled = true;
      this.generateButtonTarget.textContent = "Generating...";
    }

    this.disableMainPageDocumentControls();

    const quickViewElement = document.querySelector("#driving-school-document-quick-look");
    quickViewElement.classList.add("u-hidden");
  }

  disableMainPageDocumentControls() {
    const quickViewElement = document.querySelector("#driving-school-document-quick-look");
    const pupilToken = quickViewElement?.dataset?.pupilToken;
    const docType = quickViewElement?.dataset?.docType;

    if (!pupilToken || !docType) return;

    const row = document.querySelector(
      `[data-driving-school-student-documents-row="true"][data-pupil-token="${pupilToken}"][data-doc-type="${docType}"]`
    );

    if (!row) return;

    row.querySelectorAll(".Button").forEach((el) => {
      if (el.tagName === "A") {
        if (el.textContent.trim() === "Generate" || el.textContent.trim() === "Re-Generate") {
          el.textContent = "Generating...";
        }

        el.style.pointerEvents = "none";
        el.classList.add("Button--disabled");
        el.setAttribute("tabindex", "-1");
        el.setAttribute("aria-disabled", "true");
        return;
      }

      if (el.tagName === "BUTTON" || el.tagName === "INPUT") {
        if ((el.type || "").toLowerCase() === "submit" && el.textContent.trim() === "Download") {
          el.disabled = true;
          el.classList.add("Button--disabled");
          return;
        }

        el.disabled = true;
        el.classList.add("Button--disabled");
      }
    });
  }
}
